<template>
	<div class="maintained">
		<van-nav-bar title="功能关闭" left-text="返回" @click-left="onClickLeft"></van-nav-bar>
		<van-empty image="error" description="充值功能关闭"/>
	</div>
</template>

<script>
	export default {
		name: "maintained",
		data() {
			return {
				
			}
		},
		methods: {
			onClickLeft() {
			  this.$router.replace("/");
			},
		}
	}
</script>

<style scoped>
	.van-empty {
		height: calc(100vh - 200px);
	}
</style>